export enum ReviewTypeEnum {
    TER = 1,
    PersonalityTest = 3,
    MilioStressMap = 4,
    MilioTeamDysfunction = 5
}